import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	
	
	popupBuy: {
		'id': 'saleAndRent.popupBuy',
		'defaultMessage': 'Buy this one',
	},
	title: {
		'id': 'saleAndRent.title',
		'defaultMessage': 'Fresh Mint Bundle',
	},
	subtitle: {
		'id': 'saleAndRent.subtitle',
		'defaultMessage': 'Get a control unit and an ancillary chamber and have a second ancillary chamber for free!',
	},
	labelSale: {
		'id': 'saleAndRent.popupButtonSale',
		'defaultMessage': 'Buy FreshMint Bundle',
	},
	textSale: {
		'id': 'saleAndRent.textSale',
		'defaultMessage': 'devices at a price of 2',
	},
	textPositionSale: {
		'id': 'saleAndRent.textPositionSale',
		'defaultMessage': '1 main, 2 auxiliary',
	},
	labelRent: {
		'id': 'saleAndRent.labelRent',
		'defaultMessage': 'rent FreshMint Bundle',
	},
	textRent: {
		'id': 'saleAndRent.textRent',
		'defaultMessage': 'devices at a price of 2',
	},
	textPositionRent: {
		'id': 'saleAndRent.textPositionRent',
		'defaultMessage': '1 main, 2 auxiliary',
	},
	labelDevice: {
		'id': 'saleAndRent.labelDevice',
		'defaultMessage': 'Buy FreshMint Device',
	},
	textPositionDevice: {
		'id': 'saleAndRent.textPositionDevice',
		'defaultMessage': 'main',
	},
});


// WEBPACK FOOTER //
// ./src/components/LandingSaleAndRent/messages.js